import { render, staticRenderFns } from "./delegate-modal.vue?vue&type=template&id=4feb4aec&"
import script from "./delegate-modal.vue?vue&type=script&lang=ts&"
export * from "./delegate-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports